module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"jobNum":"Employee ID","department":"Department"},"zh":{"jobNum":"工号","department":"部门"}}')
  delete Component.options._Ctor
}
